<div class="numero_piezas">{{ numeroSolicitudes }}</div>
<div class="descripcion">Diseños analógicos</div>
